module.exports = __webpack_public_path__ + "static/apto-214-n-d95ea3681c73e37a61ff4df505a463cf.jpg";